import { MyTableComponent, Input } from "components"
import { useState, useEffect } from "react"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

import tittle from "./Tittle.png"
import slidersign from "./slidersign.png"

export const SignalTimesSystem = () => {
 // language translator
 const { t } = useTranslation("translation")
 const [selectedData, setSelectedData] = useState<any[]>([])

 const data = [
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
  {
   firstname: "Forum Gera",
   secondname: "STm.5 Forum Gera",
   thirdname: "Standleitung OCIT, Kommunikation gestört",
   fourthname: "23:01:2022   (00:00:00)",
   fifthname: "12.01.2023   (12:19:53)",
   sixthname: "1376 h",
  },
 ]

 const columns = [
  { Header: t("center"), accessor: "firstname" },
  { Header: t("Device"), accessor: "secondname" },
  { Header: t("Device"), accessor: "thirdname" },
  { Header: `${t("listenNr")}.`, accessor: "fourthname" },
  { Header: `${t("listenNr")}.`, accessor: "fifthname" },
  { Header: t("difference"), accessor: "sixthname" },
 ]

 useEffect(() => {
  if (data) {
   setSelectedData(data)
  }
  // eslint-disable-next-line
 }, [])
 const searchHandler = (keyword: any) => {
  if (keyword !== "") {
   const filterData: any = data?.filter(
    (item) => item?.secondname?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setSelectedData([...filterData])
  } else {
   setSelectedData(data)
  }
 }
 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("signalTimes")}</h1>
    <div className="bg-white h-10 w-10 rounded flex justify-center items-center">
     <img src={slidersign} alt="slidersignimg" />
    </div>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">{t("signalTimes")}</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}</p>

      <div className="bg-white h-8 w-12 rounded mx-4  border-light-gray border-[1.5px] flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded pl-2"
        placeholder={t("search")}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
